import { gql } from '@apollo/client';

export const UPDATE_PRODUCT = gql`
	mutation UpdateProduct($productId: String!, $updateProduct: UpdateOnboardingProductInput!) {
		updateProduct(productId: $productId, updateProduct: $updateProduct) {
			status
			name
			id
			imageUrl
			dateNextySelection
			nextyFinalist
			nextyWinner
			marketReady
			productCategory
			productDescription
			imagesLastUpdate
			pintoLastUpdates
			pintoStatus
			productApprovalConditions
			approvedOn
			flagshipProduct
			dimensions {
				width {
					inches
					millimeters
				}
				height {
					inches
					millimeters
				}
				depth {
					inches
					millimeters
				}
				weight {
					ounces
					grams
				}
			}
			productMSRP
			launchYear
			productGTIN
			productShelfLife
			certifiedGlutenFree
			certifiedNonGMO
			certifiedOrganic
			showHowGood
			howGoodLabel
			howGoodEstimated
			howGoodAvgEstimated
			howGoodScore
			violations {
				allergenMissing
				botanicPartsMissing
				claimsLogoRequiresCertification
				containsBannedIngredients
				directionsForUse
				ingredientsListMissing
				manufacturerAddressMissing
				misuseFDAApprovedHealthClaim
				organicCertifyingAgentMissing
				statementIdentityMissing
				unclarifiedNutrient
				missingIncorrectNFP
				missingNQC
			}
		}
	}
`;
